import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import UserAvatar from '../mini/UserAvatar'

export default class AssignmentAvatars extends PureComponent {
  render() {
    const { fromPhotoUrl, toPhotoUrl } = this.props

    return (
      <div className="assignment-avatars">
        <UserAvatar photoUrl={fromPhotoUrl} />
        <div className="arrow" />
        <UserAvatar photoUrl={toPhotoUrl} />
      </div>
    )
  }
}

AssignmentAvatars.propTypes = {
  fromPhotoUrl: PropTypes.string,
  toPhotoUrl: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/AssignmentAvatars.js